import { ReactNode } from 'react';
import { DeepMap, FieldError } from 'react-hook-form';

import ErrorMessageStyled from 'approot/shared/error-message/error-message.style';
import { spacing4 } from 'approot/shared/styles/spacing.style';

type Props = {
  errors: DeepMap<Record<string, any>, FieldError>;
  field: string;
  id?: string;
  noMarginTop?: boolean;
  marginBottom?: number;
  suffix?: ReactNode;
};

const ValidationMessage = ({
  errors,
  field,
  id,
  noMarginTop,
  marginBottom,
  suffix,
  ...rest
}: Props) => {
  const error = errors?.[field]?.message;

  return error ? (
    <ErrorMessageStyled
      data-selector={`error-${field}`}
      marginTop={noMarginTop ? 0 : spacing4}
      marginBottom={marginBottom}
      id={id}
      {...rest}
    >
      {error}
      {suffix}
    </ErrorMessageStyled>
  ) : null;
};

export default ValidationMessage;
